module.exports = __webpack_public_path__ + "img/202509_04.974584aa.jpg";